import { SPORT_URL_PART } from 'pages/Sport/_constants/SPORT_URLS'
import { urlRootPath } from 'helpers/urlPath'

export default {
  sport_id: undefined,
  sport_key: undefined,
  sport_title: undefined,
  base_url: urlRootPath(SPORT_URL_PART, 'undefined'),
  is_sport_context: false,
  federation_filter: undefined,
}
